/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2025-06-20 15:13:15
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 17:18:07
 */
import store from "@/store";
import { Message } from "element-ui";
import { routesWhiteList } from "@/config";
import { removeAccessToken, getAccessToken } from "@/plugins/auth";

function hasToken() {
  if (getAccessToken()) {
    return true;
  }
  // const { token } = qs.parse(window.location.search.slice(1));
  // if (token) {
  //   setAccessToken(token);
  //   return true;
  // }
  return false;
}

const createPermissionGuard = router => {
  router.beforeEach(async (to, from, next) => {
    if (hasToken()) {
      if (to.path === "/login") {
        next();
      } else {
        const userInfo = store.state.profile;
        if (userInfo.id) {
          // 已获取用户信息
          next();
        } else {
          // 未获取用户信息
          try {
            await store.dispatch("getUserInfo");
            next({ ...to, replace: true });
          } catch (error) {
            // 获取用户信息失败
            removeAccessToken();
            Message.warning({ message: "登录超时" });
            next(
              `/login?redirect=${to.path}&query=${JSON.stringify(to.query)}`
            );
          }
        }
      }
    } else {
      if (routesWhiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        next(`/login?redirect=${to.path}&query=${JSON.stringify(to.query)}`);
      }
    }
  });
};

/**
 * 构建路由守卫
 * @param {Router} router vue路由对象
 */
export function setupRouterGuard(router) {
  createPermissionGuard(router);
}



// WEBPACK FOOTER //
// ./src/router/guads.js